<template>
  <div class="thumbnail-row-container comission">
    <div class="row-thumbnail comission-initial">
      <div v-if="thumbnailUrl">
        <img v-bind:src="thumbnailUrl">
      </div>
      <div v-else class="initials">
        {{ initials }}
      </div>
    </div>
    <div class="row-main textContainer">
      <p v-html="rowMain"></p>
    </div>
    <div v-if="extraContent" >
      <p>{{ extraContent }}</p>
    </div>
    <div v-if="actionIcon" class="action-box">
      <p><i class="fas fa-chevron-right"></i></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'thumbnail-row',
  props: [
    'thumbnailUrl',
    'initials',
    'rowMain',
    'extraContent',
    'actionIcon'
  ]
}
</script>
